import api from "@/core/api";

export const reportData = (name: string, params: any = {}) =>
  api.query(`/reports/data/${name}`, { data: params, method: "post" });
export const reportLoad = (name: string) =>
  api.query(`/reports/load/${name}`, {}, false);
export const reportSave = (name: string, report: any) =>
  api.query(`/reports/save/${name}`, { data: report, method: "put" });
export const reportSend = (params: any = {}) =>
  api.query(`/reports/send`, { data: params, method: "post" });
export const reportsList = () => api.query(`/reports/reports`);
